import React, { useEffect, useState } from 'react';

import { HStack, Stack, Text } from '@chakra-ui/react';
import { isEmpty } from 'lodash';
import { Controller, UseFormReturn } from 'react-hook-form';

import { Icon, Select } from 'components';
import { debounceDriver, debounceDriversVehicles } from 'utils/debounces';

interface DriverFormProps extends Partial<UseFormReturn> {
  drivers: {
    name: string
    label: string
  }
  vehicle: {
    name: string
    label: string
  }
  isDisabled?: boolean
  except?: {
      label: string
      id: string
  }[]
}

export default function DriverForm({
  control, drivers, setValue, vehicle, isDisabled, watch, except,
}:DriverFormProps) {
  const fields = watch(drivers.name)?.filter((field) => !!field);
  const [forced, forceRefresh] = useState(false);

  useEffect(() => {
    if (isEmpty(fields)) {
      setValue(drivers.name.concat('.0'), { empty: true });
      forceRefresh(!forced);
    }
  }, [fields]);
  return (
    <HStack
      alignItems="flex-start"
      justify="space-between">
      <Stack
        w="100%"
        spacing={2}>
        {fields?.map((_, index) => (
          <Controller
            key={`${drivers.name}.${index}`}
            control={control}
            name={`${drivers.name}.${index}`}
            // defaultValue={fields?.[index] ?? {}}
            render={({ field }) => (
              <HStack
                justifyContent="center"
                alignItems="center">
                <Select
                  disabledOptions={except}
                  onSelect={() => {
                    setValue(vehicle.name, { });
                  }}
                  isDisabled={isDisabled}
                  label={drivers.label}
                  loadOptions={debounceDriver}
                  {...field}
                />
                {index && (
                  <Icon
                    cursor="pointer"
                    onClick={() => {
                      setValue(drivers.name.concat(`.${index}`), undefined);
                    }}
                    position="relative"
                    top={2}
                    color="gray.500"
                    name="trash"
                  />
                )}
              </HStack>
            )}
          />
        ))}
        {!isDisabled && (
        <Text
          cursor="pointer"
          color="gray.400"
          onClick={() => setValue(drivers.name.concat(`.${fields.length}`), { empty: true })}
          variant="smallRegular"
          textDecoration="underline">+ Adicionar motorista
        </Text>
        )}
      </Stack>
      <Controller
        control={control}
        name={vehicle.name}
        rules={{
          required: 'Selecione um veículo',
          validate: ({ id }) => {
            if (!id) {
              return 'Selecione um veículo';
            }
            return null;
          },
        }}
        render={({ field }) => {
          if (!isEmpty(fields) && !fields?.[0].empty) {
            return (
              <Select
                isDisabled={isDisabled}
                label={vehicle.label}
                watch={fields}
                loadOptions={debounceDriversVehicles(fields?.map((driver) => driver?.label))}
                {...field}
              />
            );
          }
          return null;
        }}
      />
    </HStack>
  );
}
